// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_240z","has-val":"_3X4X","pos-r":"_2cYA"};


//////////////////
// WEBPACK FOOTER
// ./form/components/inputs/user-amount/style.css
// module id = kSUl
// module chunks = 4